/* REACT IMPORTS */
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

/* STYLES */
import "../styles/global.css";

/* LAYOUT */
import Layout from "../layout";

/* PAGES */
import AuthLogin from "../pages/auth/login";
import AuthRegister from "../pages/auth/register";
import Dashboard from "../pages/dashboard";
import Orders from "../pages/dashboard/orders";
import OrderDetails from "../pages/dashboard/orders/order-details/";
import InvoiceDetails from "../pages/dashboard/orders/invoice";
import Customers from "../pages/dashboard/customers";
import CustomerDashboard from "../pages/dashboard/customers/customer-dashboard";
import Inventory from "../pages/dashboard/inventory";
import AddProduct from "../pages/dashboard/inventory/add-product";
import ViewProduct from "../pages/dashboard/inventory/view-product";
import EditProduct from "../pages/dashboard/inventory/edit-product";
import Categories from "../pages/dashboard/categories";
import Tags from "../pages/dashboard/tags";
import OffersAndPromocodes from "../pages/dashboard/offers-and-promocodes";
import ContactUs from "../pages/dashboard/contact-us";
import Newsletter from "../pages/dashboard/newsletter";
import Vendors from "../pages/dashboard/vendors";
import VendorDetails from "../pages/dashboard/vendors/view-details";
import VendorEditDetails from "../pages/dashboard/vendors/edit-details";
import Career from "../pages/dashboard/career";

/* SCROLL TO TOP */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const AppRoutes = () => {
  return (
    <div className="app">
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<AuthLogin />} />
          <Route path="/register" element={<AuthRegister />} />
          <Route
            path="/dashboard"
            element={<Navigate to="/orders" replace />}
          />
          <Route
            path="/orders"
            element={
              <Layout>
                <Orders />
              </Layout>
            }
          />
          <Route
            path="/order/:id"
            element={
              <Layout>
                <OrderDetails />
              </Layout>
            }
          />
          <Route
            path="/invoice/:id"
            element={
              <Layout>
                <InvoiceDetails />
              </Layout>
            }
          />
          <Route
            path="/customers"
            element={
              <Layout>
                <Customers />
              </Layout>
            }
          />
          <Route
            path="/customers/:id"
            element={
              <Layout>
                <CustomerDashboard />
              </Layout>
            }
          />

          <Route
            path="/inventory"
            element={
              <Layout>
                <Inventory />
              </Layout>
            }
          />
          <Route
            path="/inventory/add-product"
            element={
              <Layout>
                <AddProduct />
              </Layout>
            }
          />
          <Route
            path="/inventory/view-product/:id"
            element={
              <Layout>
                <ViewProduct />
              </Layout>
            }
          />
          <Route
            path="/inventory/edit-product/:id"
            element={
              <Layout>
                <EditProduct />
              </Layout>
            }
          />
          <Route
            path="/categories"
            element={
              <Layout>
                <Categories />
              </Layout>
            }
          />
          <Route
            path="/tags"
            element={
              <Layout>
                <Tags />
              </Layout>
            }
          />
          <Route
            path="/offers-and-promocodes"
            element={
              <Layout>
                <OffersAndPromocodes />
              </Layout>
            }
          />
          <Route
            path="/contact-us"
            element={
              <Layout>
                <ContactUs />
              </Layout>
            }
          />
          <Route
            path="/newsletter"
            element={
              <Layout>
                <Newsletter />
              </Layout>
            }
          />
          <Route
            path="/vendors"
            element={
              <Layout>
                <Vendors />
              </Layout>
            }
          />
          <Route
            path="/vendor/view/:id"
            element={
              <Layout>
                <VendorDetails />
              </Layout>
            }
          />
          <Route
            path="/vendor/edit/:id"
            element={
              <Layout>
                <VendorEditDetails />
              </Layout>
            }
          />
           <Route
            path="/career"
            element={
              <Layout>
                <Career />
              </Layout>
            }
          />
        </Routes>
      </Router>
    </div>
  );
};

export default AppRoutes;
